module.exports = __webpack_public_path__ + "static/media/pin.48e8f510.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin.svg
// module id = 1270
// module chunks = 0